import { composeMask } from '@salutejs/plasma-new-hope/css';

import { TextField } from '../TextField';

export const Mask = composeMask(TextField);
